import UrlShortenerItem from "../Contents/UrlShortenerAdmin/UrlShortenerItem.js";
import dateTimeHelper from "../Helpers/datetimeHelper.js";
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import UrlShortenerSearchParams from '../Contents/UrlShortenerAdmin/UrlShortenerSearchParams';

export default class UrlShortenerService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();
    const tempSearchItem = { ...searchItem };
    tempSearchItem.StartDate = dateTimeHelper.startOfTheDay(tempSearchItem.StartDate);
    tempSearchItem.EndDate = dateTimeHelper.endOfTheDay(tempSearchItem.EndDate);

    let url = '/api/UrlShortener/GetBySearchParams/?';
    const searchParams = new SearchParams(tempSearchItem, UrlShortenerSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new UrlShortenerItem(item));
    }

    return [];
  }

  static EditShortUrl(shortUrl) {
    shortUrl = serviceHelper.ConvertAllPropertyToString(shortUrl);
    const urlShortenerJSON = JSON.stringify(shortUrl);

    return AuthService.getInstance().CallBackendFunctionPut('/api/UrlShortener/InsertUpdateShortUrl', urlShortenerJSON);
  }
}
